import { useState, useRef } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';

type CustomSplitButtonType = {
  children?: React.ReactNode;
  id: string;
  variant: string;
  title: string;
  className: string;
  onClick: () => void;
}

export default function CustomSplitButton(props: CustomSplitButtonType) {
  const { onClick, ...rest } = props;
  const [show, setShow] = useState(false);
  const [itemEnter, setItemEnter] = useState(false);
  const tId = useRef<NodeJS.Timeout | null>(null);

  return (
    <Dropdown {...rest} as={ButtonGroup} show={show}>
      <Button variant="primary" onClick={ onClick }>
        {props.title}
      </Button>

      <Dropdown.Toggle
        split
        variant="primary"
        onMouseEnter={() =>           
          setShow(true)
        }
        onMouseLeave={() => {
          tId.current=setTimeout(()=>setShow(false),300)
        }}
      />

      <Dropdown.Menu
        onMouseEnter={() => {
          if (tId.current) {
            clearTimeout(tId.current);
            tId.current = null;
          }
        }} 
        onMouseLeave={() => setShow(false)}
      >
        { rest.children }
      </Dropdown.Menu>
    </Dropdown>
  );
}
